/* User */
export const SET_ACTIVE_USER = 'SET_ACTIVE_USER'
export const UPDATE_ACTIVE_USER_NAME = 'UPDATE_ACTIVE_USER_NAME'
export const CLEAR_USER_VARIABLES = 'CLEAR_USER_VARIABLES'

/* Account */
export const SET_ACTIVE_USER_ACCOUNTS = 'SET_ACTIVE_USER_ACCOUNTS'
export const SET_ACTIVE_ACCOUNT = 'SET_ACTIVE_ACCOUNT'
export const SET_ACTIVE_BUSINESS_ID = 'SET_ACTIVE_BUSINESS_ID'
export const SET_ACTIVE_BUSINESS_NAME = 'SET_ACTIVE_BUSINESS_NAME'
export const CLEAR_ACTIVE_BUSINESS = 'CLEAR_ACTIVE_BUSINESS'
export const SET_ACTIVE_LOCATION_ID = 'SET_ACTIVE_LOCATION_ID'
export const SET_ACTIVE_LOCATION_NAME = 'SET_ACTIVE_LOCATION_NAME'
export const CLEAR_ACTIVE_LOCATION = 'CLEAR_ACTIVE_LOCATION'
export const CLEAR_ACCOUNT_VARIABLES = 'CLEAR_ACCOUNT_VARIABLES'
export const SET_APP_LIST = 'SET_APP_LIST'
export const SET_ROLE_APP_LIST = 'SET_ROLE_APP_LIST'
export const SET_V3_TOKEN = 'SET_V3_TOKEN'

/* Google */
export const SET_GOOGLE_FONTS = 'SET_GOOGLE_FONTS'



// WEBPACK FOOTER //
// ./src/store/mutation-types.js